import { IDocumentAssemblerGenerationPlaceholder } from '@commenda/api';
import { Badge } from '@commenda/kakashi';

import { DocumentAssemblerHelper } from './DocumentAssemblerHelper';

interface DocumentAssemblerGenerationSummaryStripProps {
  placeholders: IDocumentAssemblerGenerationPlaceholder[];
}

export const DocumentAssemblerGenerationSummaryStrip = ({
  placeholders,
}: DocumentAssemblerGenerationSummaryStripProps) => {
  const tally = DocumentAssemblerHelper.tally(placeholders);

  return (
    <div className="flex flex-wrap items-center gap-sm">
      <Badge variant="success" size="sm">
        {tally.written} written
      </Badge>
      <Badge variant={tally.pending > 0 ? 'warning' : 'gray'} size="sm">
        {tally.pending} left pending
      </Badge>
      {tally.undecided > 0 ? (
        <Badge variant="warning" size="sm">
          {tally.undecided} awaiting a branch decision
        </Badge>
      ) : null}
      {tally.leftOut > 0 ? (
        <Badge variant="gray" size="sm">
          {tally.leftOut} removed by a branch decision
        </Badge>
      ) : null}
      <span className="txt-extra-small-regular text-text-tertiary">
        of {placeholders.length} slots the template asked for
      </span>
    </div>
  );
};
